"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.fetchProductProperties = exports.fetchContactProperties = exports.fetchCompanyProperties = void 0;

var _reduxObservable = require("redux-observable");

var _requestEntity = _interopRequireDefault(require("../requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("../RequestEpicDescriptor"));

var _actions = require("./actions");

var _selectors = require("./selectors");

var _API = _interopRequireDefault(require("./API"));

var _RequestStatusTypes = _interopRequireDefault(require("../constants/RequestStatusTypes"));

var fetchCompanyProperties = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getCompanyProperties,
  initiatingActionType: _actions.PropertyActionTypes.LOAD_COMPANY_PROPERTIES,
  requestStatusSelector: _selectors.getFetchCompanyPropertiesRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchCompanyProperties
}));
exports.fetchCompanyProperties = fetchCompanyProperties;
var fetchContactProperties = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getContactProperties,
  initiatingActionType: _actions.PropertyActionTypes.LOAD_CONTACT_PROPERTIES,
  requestStatusSelector: _selectors.getFetchContactPropertiesRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchContactProperties
}));
exports.fetchContactProperties = fetchContactProperties;
var fetchProductProperties = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getProductProperties,
  initiatingActionType: _actions.PropertyActionTypes.LOAD_PRODUCT_PROPERTIES,
  requestStatusSelector: _selectors.getFetchProductPropertiesRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchProductProperties
}));
exports.fetchProductProperties = fetchProductProperties;

var _default = (0, _reduxObservable.combineEpics)(fetchCompanyProperties, fetchContactProperties, fetchProductProperties);

exports.default = _default;